import { Draft, PayloadAction } from '@reduxjs/toolkit';
import { IPaymentState } from 'Redux/Slices/Payment/PaymentSlice';
import { SinglePaymentOffer, SubscriptionOffer } from 'api/graphql';

type TPayload = { offer: SinglePaymentOffer | SubscriptionOffer };

export const setSelectedOffer = (state: Draft<IPaymentState>, { payload }: PayloadAction<TPayload>) => {
  state.selectedOffer = payload.offer;
  state.updatedAt = Date.now();
};
